<div>
    Task Form
    <form [formGroup]="formGroup">
        <div class="flex">
            <div class="w-6 px-4">
                <app-form-element [formGroup]="formGroup"
                                  [formId]="'project'"
                                  [formLabel]="'Project'"
                                  [formValues]="projectValues"
                                  [type]="FormTypes.SELECT">
                </app-form-element>
                <app-form-element [formGroup]="formGroup"
                                  [formId]="'taskState'"
                                  [formLabel]="'Task State'"
                                  [type]="FormTypes.SELECT">
                </app-form-element>
                <div class="pt-5 relative">
                    <span class="absolute text-sm text-gray-500 custom-form-el-title">Target Date</span>
                    <p-calendar
                        formControlName="targetDate"
                        [showIcon]="true"
                        inputId="buttondisplay"
                        [showOnFocus]="false"/>
                </div>
                <app-form-element [formGroup]="formGroup"
                                  [formId]="'sendToRecipient'"
                                  [formLabel]="'Task will sent instantly to recipient'"
                                  [type]="FormTypes.CHECKBOX">
                </app-form-element>
            </div>
            <div class="w-6 px-4">
                <app-form-element [formGroup]="formGroup"
                                  [formId]="'sendForm'"
                                  [formLabel]="'Send Form'"
                                  [type]="FormTypes.SELECT">
                </app-form-element>
                <app-form-element [formGroup]="formGroup"
                                  [formId]="'priority'"
                                  [formLabel]="'Priority'"
                                  [type]="FormTypes.SELECT">
                </app-form-element>
                <!--recurring begin-->
                <p-inputGroup class="pt-5 relative">
                    <p-inputGroupAddon>Every</p-inputGroupAddon>
                    <div class="w-2">
                        <input type="text" pInputText formControlName="recurring" class="border-noround"/>
                    </div>
                    <select class="w-8 border-1 border-gray-300" style="border-radius: 0 6px 6px 0;"
                            formControlName="recurringPeriod">
                        <option *ngFor="let period of timePeriods" value="{{period.value}}"
                                class="text-lg">{{ period.label }}
                        </option>
                    </select>
                    <span class="absolute text-sm text-gray-500 custom-form-el-title">Recurring</span>
                </p-inputGroup>
                <!--recurring end-->
                <!--reminder begin-->
                <p-inputGroup class="pt-5 relative w-full">
                    <p-inputGroupAddon>Before</p-inputGroupAddon>
                    <div class="w-2">
                        <input type="text" pInputText formControlName="reminder" class="w-6"
                               style="border-radius: 6px 0 0 6px;"/>
                    </div>
                    <span class="absolute text-sm text-gray-500 custom-form-el-title">Reminder</span>
                    <select class="border-1 border-gray-300 w-8" formControlName="reminderPeriod">
                        <option *ngFor="let period of timePeriods" value="{{period.value}}"
                                class="text-lg">{{ period.label }}
                        </option>
                    </select>
                </p-inputGroup>
                <!--reminder end-->
            </div>
        </div>
        <div class="px-4">
            <app-form-element [formGroup]="formGroup"
                              [formId]="'title'"
                              [formLabel]="'title'"
                              [type]="FormTypes.TEXT">
            </app-form-element>
            <div class="mt-6">
                <span class="text-gray-500 p-2">Task Description</span>
                <p-editor formControlName="taskDescription" [style]="{ height: '120px' }"/>
            </div>
            <div class="mt-6">
                <span class="text-gray-500 p-2">Acceptence Information</span>
                <p-editor formControlName="acceptanceInfo" [style]="{ height: '120px' }"/>
            </div>
            <div class="pt-5 flex align-items-center">
                <p-inputSwitch formControlName="sendToGroup"/>
                <span class="font-bold pb-1 pl-2">{{ 'task.send-to-group' | translate }}</span>
            </div>
            <app-form-element [formGroup]="formGroup"
                              [formId]="'responsiblePerson'"
                              [formLabel]="'Responsible person'"
                              [type]="FormTypes.SELECT"
                              *ngIf="!formGroup.value?.sendToGroup">
            </app-form-element>
            <app-form-element [formGroup]="formGroup"
                              [formId]="'responsibleGroup'"
                              [formLabel]="'Responsible group'"
                              [type]="FormTypes.SELECT"
                              *ngIf="formGroup.value?.sendToGroup">
            </app-form-element>
            <div class="mt-5 p-3 flex justify-content-center border-gray-300 border-1 border-round-lg">
                <p-fileUpload
                    class="border-0"
                    name="demo[]"
                    url="https://www.primefaces.org/cdn/api/upload.php"
                    (onUpload)="onUpload($event)"
                    [multiple]="true"
                    accept="image/*"
                    maxFileSize="1000000">
                    <ng-template pTemplate="content">
                        <ul *ngIf="uploadedFiles.length">
                            <li *ngFor="let file of uploadedFiles">
                                {{ file.name }} - {{ file.size }} bytes
                            </li>
                        </ul>
                    </ng-template>
                </p-fileUpload>
                <!--                <span class="w-4 inline-block text-gray-500">Files</span>-->
                <!--                <span class="w-8 inline-block text-gray-500">Click to add or see attached files</span>-->
                <!--                <input type="file" name="" id="" class="w-full py-3 z-5 absolute left-0 top-0 opacity-0">-->
            </div>
        </div>
        <div class="p-4 flex justify-content-end">
            <p-button class="mr-4">{{ 'dms.cancel' | translate }}</p-button>
            <p-button (click)="confirmForm()">{{ 'sipo.save' | translate }}</p-button>
        </div>
    </form>
</div>
